import styled from '@emotion/styled';
import { Badge } from '@src/container/component/common';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { ComicType } from '../../episode/constants';
import { Top100Itemtype } from '../types/Top100Type';
import Button from './Button';

const Thumbnail = ({ onClick, src, alt, validation }: any) => {
  if (!src) {
    return (
      <span onClick={onClick} className="img_thumb">
        <div className="dummy thumb_loading"></div>
      </span>
    );
  } else {
    return (
      <span onClick={onClick} className="img_thumb">
        <img src={src} alt={alt} />
      </span>
    );
  }
};

const Top100Item = (props: Top100Itemtype) => {
  const {
    comicId,
    firstEpisodeId,
    rank,
    imgPath,
    title,
    comicType,
    isNew,
    isUpdate,
    authors,
    viewCount,
    rating,
    description,
  } = props;
  const router = useRouter();
  const { t } = useTranslation('common');
  const EpisodeListMove = () => {
    router.push(`/comic/${comicId}`);
  };

  const firstEpMove = () => {
    if (firstEpisodeId !== 0) {
      router.push(`/comic/${comicId}/${firstEpisodeId}`);
    }
  };
  return (
    <Top100Style rank={rank}>
      <div className="rank">
        <span className="rank_num">{rank}</span>
        {/* <span className="status">
          <Badge type="rank_up" />
        </span> */}
      </div>
      <Thumbnail onClick={EpisodeListMove} src={imgPath} alt={title} />
      <div onClick={() => EpisodeListMove()} className="comic_info_wp">
        <div>
          <span>
            {comicType === ComicType.SRRCK ? (
              <Badge className={'mr2'} type="srrck" height={'15px'} />
            ) : (
              <Badge type="comic" height={'15px'} />
            )}
          </span>
          <div className="title_area">
            {isUpdate && (
              <Badge type="up" validation={isUpdate} className="mr2 mt5" />
            )}
            {isNew && (
              <Badge type="new" validation={isNew} className="mr2 mt5" />
            )}
            <p className="title">{title}</p>
          </div>
          <p className="author">{authors}</p>
        </div>
        <div className="comic_etc">
          <div className="view">
            <Badge type="view" className="mr1 mt2" />
            {/* <span className="view_count">{props.viewCount}</span> */}
            <span className="view_count">{viewCount} View</span>
          </div>
          <span className="comic_grade">
            <Badge type="star" height="14px" className="mt1 mr2" />
            {rating}
          </span>
        </div>
        <div className="comic_description">{description}</div>
      </div>
      <div className="btn_area">
        <Button colorType="currency" onClick={firstEpMove}>
          {t('top_100_free')}
        </Button>
        <Button colorType="coin" onClick={EpisodeListMove}>
          {t('top_100_home')}
        </Button>
      </div>
    </Top100Style>
  );
};

export default Top100Item;

interface Top100StyledProp {
  rank: number;
}

export const RankColor = (rank: number) => {
  switch (rank) {
    case 0: {
      return '#e7bb5c';
    }
    case 1: {
      return '#AEB1BB';
    }
    case 2: {
      return '#D28D72';
    }
    default: {
      return '#333333';
    }
  }
};

const Top100Style = styled.li<Top100StyledProp>`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: flex-start;
  padding-bottom: 20px;
  margin-top: 20px;
  &:not(:last-of-type) {
    border-bottom: 1px solid #eee;
  }
  .rank {
    display: flex;
    align-items: center;
    float: left;
    padding: 2px 0;
    position: absolute;
    left: 0;
    top: 10px;
    .rank_num {
      font-size: 1.7rem;
      font-weight: 600;
      font-family: 'roboto';
      color: #333;
      display: inline-block;
      float: left;
      color: ${({ rank }) => RankColor(rank)};
    }
    .status {
      margin-left: 3px;
      .badge {
        height: 15px;
      }
    }
  }
  .img_thumb {
    float: left;
    display: inline-flex;
    width: 160px;
    position: relative;
    margin-left: 50px;
    cursor: pointer;
    > img {
      aspect-ratio: 160 / 224;
      display: inline-block;
    }
    > .dummy {
      aspect-ratio: 160 / 224;
    }
  }
  .comic_info_wp {
    display: inline-block;
    float: left;
    width: calc(100% - 210px);
    padding-left: 20px;
    max-width: 600px;
    line-height: normal;
    font-size: 0;
    cursor: pointer;
    .title_area {
      height: 1.5rem;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      margin-bottom: 2px;
      margin-top: 2px;
      .title {
        font-size: 1.2rem;
        color: #333;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        padding: 2px 0;
      }
    }
    .author {
      color: #aaa;
      font-size: 0.625rem;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: keep-all;
      width: 100%;
      max-height: 2.2rem;
      margin-bottom: 1px;
    }
    .comic_description {
      color: #aaa;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: keep-all;
      margin-top: 10px;
      line-height: 1.1rem;
      max-height: 3.4rem;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      letter-spacing: -0.2px;
    }
  }

  .comic_etc {
    overflow: hidden;
    .view,
    .comic_grade {
      color: #aaa;
      font-size: 0.625rem;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: keep-all;
      max-height: 2.2rem;
      display: inline-flex;
      align-items: center;
      vertical-align: top;
      float: left;
      .viewCount {
        display: inline-block;
        vertical-align: top;
        padding: 0 1px;
      }
    }
    .view {
    }
    .comic_grade {
      margin-left: 5px;
      padding: 0 1px;
    }
  }
  .btn_area {
    display: flex;
    flex-direction: column;
    > button {
      + button {
        // 근접한 button 태그에
        margin-top: 8px;
      }
    }
  }
  @media ${({ theme }) => theme.breakPoint.mobileAndTablet} {
    width: 100%;
    display: block;
    &:before {
      content: '';
      visibility: hidden;
      display: block;
      height: 0;
      clear: both;
    }
    &:after {
      content: '';
      visibility: hidden;
      display: block;
      height: 0;
      clear: both;
    }
    .rank {
      .rank_num {
        font-size: 1.2rem;
      }
      .status {
        .badge {
          height: 10px;
        }
      }
    }
    .img_thumb {
      flex: none;
      width: 90px;
      margin-left: 30px;
      > img {
      }
      > .dummy {
      }
    }
    .comic_info_wp {
      width: calc(100% - 120px);
      padding-left: 12px;
      .title_area {
        .badge {
          height: 13px;
          margin-top: 2px;
        }
        .title {
          font-size: 17px;
        }
      }
      .author {
      }
      .comic_description {
        font-size: 11px;
      }
    }

    .comic_etc {
      .view,
      .comic_grade {
        .viewCount {
        }
      }
      .comic_grade {
        > .badge {
          height: 12px;
        }
      }
    }
    .btn_area {
      width: calc(100% - 28px);
      flex-direction: row;
      justify-content: space-around;
      float: right;
      margin-top: 15px;
      > button {
        width: 49%;
        height: 36px;
        + button {
          margin-top: auto;
          margin-left: 5px;
        }
      }
    }
  }
`;
